import { render, staticRenderFns } from "./ButtonFooter.vue?vue&type=template&id=03cdbacd&"
import script from "./ButtonFooter.vue?vue&type=script&lang=js&"
export * from "./ButtonFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports